import React, { useEffect, useRef, useState } from "react";
import { ServiceWrapper } from "@/res/context/ServiceContext";
import { pageTitle } from "@/res/helpers/PageHelper";
import Card from "@/res/components/ClientCreate/card";
import { initialiseClient, IS_SERVER } from "@/res/helpers/ServiceHelper";
import { ACTIONS } from "@/res/reducers/ServiceReducer";

const ContentWrapper = (props) => {
    const contextRef = useRef();
    const [initing, setIniting] = useState(false);

    useEffect(() => {
        if (IS_SERVER || contextRef?.current == null || initing) return;

        if (["AUNO", "ACUS", "ACNO", "LENO", "SEIN"].includes(contextRef?.current?.state?.shared?.service_code) && (contextRef?.current?.state?.shared?.reference?.length ?? 0) === 0) {
            setIniting(true)
            initClient().finally(() => {
                setIniting(false);
            });
        }
    }, [contextRef?.current?.state?.shared]);

    const initClient = async () => {
        let assistedBy = props?.isSales ? "SALES" : null;

        contextRef?.current?.dispatch({
            type: ACTIONS.SAVE,
            payload: {
                shared: {
                    reference: await initialiseClient({ ...contextRef?.current?.state, assistedBy }),
                },
            },
        })
    };

    return (
        <ServiceWrapper contextRef={contextRef} lite={true} initial={true}>
            { pageTitle(props?.title ?? "") }

            <main>
                <section className="cover section-center disable-pointer-events">
                    <div className="container funnel-container-bottom-buffer">
                        <div className="row justify-content-center">
                            <div className="col-12 col-lg-6 center-tablet-down">
                                {props?.children}
                            </div>
                            <div className="col-lg-1"/>
                            <div className="col-12 col-sm-8 col-lg-5">
                                { (props?.inDevelopment !== false || props?.isSales) && props?.isMultiMode &&
                                    <div style={{ margin: "3.5rem 0 0" }} className="show-tablet-and-down"/>
                                } {/* TODO - the margin above */}
                                <Card
                                    country={props?.country}
                                    isAmlEnabled={props?.isAmlEnabled}
                                    inDevelopment={props?.inDevelopment}
                                    isSearchable={props?.isSearchable}
                                    isMultiMode={props?.isMultiMode}
                                    defaultMode={props?.details?.settings?.default_mode ?? "BUSINESS"}
                                    isSales={props?.isSales}
                                    urlParams={props?.urlParams}
                                />
                            </div>
                        </div>
                    </div>
                </section>
            </main>
        </ServiceWrapper>
    );
};

export default ContentWrapper;
